"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSaveSearchDialogTranslate = void 0;
exports.defaultSaveSearchDialogTranslate = {
    title: 'Update / Save Your Search',
    save: 'Save',
    saveNew: 'Save New',
    update: 'Update',
    cancel: 'Cancel',
    defaultName: 'Name of this criteria (eg. Home Sweet home)',
    andMore: 'and more',
    criteria: 'Crieteria',
    contract: 'Type',
    forSale: 'For Sale',
    forRent: 'For Rent',
    keyword: 'Keyword',
    district: 'District',
    price: 'Price',
    size: 'Size',
    beds: 'Bedrooms',
    amenity: 'Amenities',
    type: 'Property Type',
    sort: 'Sort',
};
